export default "__VITE_ASSET__ChOA5eow__"